// Drafts contain no credentials and are never persisted. Existing images are retained by ID.
const photoTypes = {
    jpg: 'image/jpeg', jpeg: 'image/jpeg', jfif: 'image/jpeg', jpe: 'image/jpeg',
    png: 'image/png', apng: 'image/png', webp: 'image/webp',
    heic: 'image/heic', heif: 'image/heif', avif: 'image/avif', gif: 'image/gif',
    bmp: 'image/bmp', tif: 'image/tiff', tiff: 'image/tiff',
}
const photoAliases = {
    'image/jpg': 'image/jpeg', 'image/pjpeg': 'image/jpeg', 'image/x-png': 'image/png',
    'image/apng': 'image/png',
    'image/heic-sequence': 'image/heic', 'image/heif-sequence': 'image/heif',
    'image/avif-sequence': 'image/avif', 'image/x-ms-bmp': 'image/bmp',
    'image/x-bmp': 'image/bmp', 'image/x-tiff': 'image/tiff',
}
export const PHOTO_ACCEPT = [...new Set(Object.values(photoTypes)), ...Object.keys(photoTypes).map(ext => `.${ext}`)].join(',')

export function photoMimeType(file) {
    const type = (file.type || '').toLowerCase().split(';')[0].trim()
    if (!type || type === 'application/octet-stream') return photoTypes[file.name.split('.').pop().toLowerCase()] || null
    return photoAliases[type] || (Object.values(photoTypes).includes(type) ? type : null)
}

export function draftSignature(items) {
    return JSON.stringify(items.map(({ id, name, plate_number, file }) => ({
        id: id || null, name: name || '', plate_number: plate_number || '',
        file: file ? [file.name, file.size, file.lastModified] : null,
    })))
}

export function normalizePlate(value) {
    const letters = { А: 'A', В: 'B', Е: 'E', І: 'I', К: 'K', М: 'M', Н: 'H', О: 'O', Р: 'P', С: 'C', Т: 'T', У: 'Y', Х: 'X' }
    return value.trim().toUpperCase().replace(/[АВЕІКМНОРСТУХ]/g, letter => letters[letter])
}

export function validateDraft(kind, items, limit) {
    const saved = items.filter(item => item.id || item.file || item.name.trim() || item.plate_number?.trim())
    if (saved.length > limit) return 'myHome.limitExceeded'
    if (saved.some(item => item.name.trim().length > 255)) return 'myHome.invalidName'
    if (kind === 'photos') {
        if (saved.some(item => !item.id && !item.file)) return 'myHome.photoRequired'
        if (saved.reduce((total, item) => total + (item.file?.size || 0), 0) > 20 * 1024 * 1024) return 'myHome.photoSize'
    } else {
        const numbers = saved.map(item => normalizePlate(item.plate_number))
        if (numbers.some(number => !/^[A-Z0-9-]{1,20}$/.test(number)) || new Set(numbers).size !== numbers.length) return 'myHome.invalidPlate'
    }
    return null
}

export function savedDraftItems(items) {
    return items.filter(item => item.id || item.file || item.name.trim() || item.plate_number?.trim())
}

export function photoSaveForm(items) {
    const form = new FormData()
    const photos = savedDraftItems(items).map((item, index) => {
        const photo = { name: item.name.trim() || null }
        if (item.id) photo.id = item.id
        if (item.file) {
            photo.upload = `photo_${index}`
            form.append(`uploads[${photo.upload}]`, item.file, item.file.name)
        }
        return photo
    })
    form.append('photos', JSON.stringify(photos))
    return form
}

export function vehicleSaveItems(items) {
    return savedDraftItems(items).map(item => ({
        ...(item.id ? { id: item.id } : {}),
        name: item.name.trim() || null, plate_number: normalizePlate(item.plate_number),
    }))
}
